import {
  PartnershipRequestInvoker,
  SupplierDetailContext,
  SupplierInformation,
} from '@purchase/supplier';
import SupplierBasicDetail from './SupplierInfo/index';
import { FC, useMemo, useState } from 'react';
import React from 'react';
import '@purchase/supplier/dist/index.css';
import { Spin, Tabs } from '@bedrock/components';
import { DeviceManagement } from '@mpc/components';
import './index.less';

/** 档案信息内容组件 */
export const ArchiveContent: FC<{
  vendorDetailData: any;
  vendorId: string;
  renderReminder?: () => React.ReactNode;
}> = ({ vendorDetailData, vendorId, renderReminder }) => {
  const hasCompletedWholeModification = useMemo(() => {
    return vendorDetailData?.extendAttributeInfo?.hasCompletedWholeModification;
  }, [vendorDetailData]);

  return (
    <SupplierDetailContext.Provider value={{ partnership: true }}>
      {renderReminder?.()}
      <SupplierInformation data={vendorDetailData}>
        {({
          data,
          isChinaEnterprise,
          isOverseaEnterprise,
          isOverseaPerson,
        }) => {
          return (
            <SupplierBasicDetail
              formDetail={data}
              isOverseas={isOverseaPerson || isOverseaEnterprise}
              hasCompletedWholeModification={hasCompletedWholeModification}
              isCompany={isChinaEnterprise || isOverseaEnterprise}
              vendorId={vendorId}
            />
          );
        }}
      </SupplierInformation>
    </SupplierDetailContext.Provider>
  );
};

/** 设备信息内容组件 */
export const DeviceInfoContent: FC<{
  vendorId: string;
}> = ({ vendorId }) => {
  return (
    <DeviceManagement
      vendorId={vendorId}
      fetchList={
        PartnershipRequestInvoker.getInstance()
          .openApiVendorPlatformPartnershipDeviceInfoQuery
      }
      addDevice={
        PartnershipRequestInvoker.getInstance()
          .openApiVendorPlatformPartnershipDeviceInfoAdd
      }
      updateDevice={
        PartnershipRequestInvoker.getInstance()
          .openApiVendorPlatformPartnershipDeviceInfoUpdate
      }
      deleteDevice={
        PartnershipRequestInvoker.getInstance()
          .openApiVendorPlatformPartnershipDeviceInfoDelete
      }
    />
  );
};

const SupplierDetailBase: FC<{
  vendorDetailData: any;
  loading: boolean;
  vendorId: string;
  renderReminder?: () => React.ReactNode;
}> = ({ vendorDetailData, loading, vendorId, renderReminder }) => {
  if (loading) {
    return <Spin />;
  }

  return (
    <div className="custom-mpc-external-supplier-detail">
      <Tabs defaultActiveKey="archive">
        <Tabs.TabPane tab="档案信息" key="archive">
          <ArchiveContent
            vendorDetailData={vendorDetailData}
            vendorId={vendorId}
            renderReminder={renderReminder}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="设备信息" key="deviceInfo">
          <DeviceInfoContent vendorId={vendorId} />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default SupplierDetailBase;
